module.exports = __webpack_public_path__ + "img/bandeau_kkbb2.ea2af44e.png";